import type { SvgIconProps } from '@mui/material/SvgIcon';
import type * as React from 'react';

import ShareIcon from '@mui/icons-material/Share';
import SvgIcon from '@mui/material/SvgIcon';

import { android } from '@egr/xbox/utils/UserAgent';

export const ExportIcon: React.FC<SvgIconProps> = (props) => {
    if (android) {
        return <ShareIcon data-testid="exportIcon" {...props}/>;
    }

    return (
        <SvgIcon data-testid="exportIcon" {...props}>
            <path d="M18,7h-3v2h3v10H6V9h3V7H6C4.896,7,4,7.896,4,9v10c0,1.104,0.896,2,2,2h12c1.104,0,2-0.896,2-2V9 C20,7.896,19.104,7,18,7z"/>
            <polygon points="15.949,3.936 12,0 8.051,3.936 9.465,5.35 11,3.814 11,15 13,15 13,3.814 14.535,5.35 "/>
        </SvgIcon>
    );
};